import React, { useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import "../css/Dashboard.css"
import InsertForm from './Admin/InsertForm';
import UpdateForm from './Admin/UpdateForm';
import DeleteForm from './Admin/DeleteForm';
import DisplayCustomers from './Admin/DisplayCustomers';
import Enquiry from './Admin/Enquiry';

const Dashboard = ({apiUrl}) => {
  const navigate = useNavigate();
  const [activeForm, setActiveForm] = useState(null);
  const admin  = localStorage.getItem('username')
  const handleButtonClick = (operation) => {
    switch (operation) {
      case 'Dashboard':
        setActiveForm(null)
        navigate('/dashboard');
        break;
      case 'Insert':
        setActiveForm(<InsertForm apiUrl={apiUrl}/>);
        navigate('/dashboard/customer/insert');
        break;
      case 'Update':
        setActiveForm(<UpdateForm apiUrl={apiUrl}/>);
        navigate('/dashboard/customer/update');
        break;
      case 'Display':
        setActiveForm(<DisplayCustomers apiUrl={apiUrl}/>);
        navigate('/dashboard/customer/display');
        break;
      case 'Delete':
        setActiveForm(<DeleteForm apiUrl={apiUrl}/>);
        navigate('/dashboard/customer/delete');
        break;
      case 'Enquiry':
          setActiveForm(<Enquiry apiUrl={apiUrl}/>);
          navigate('/dashboard/customer/enquiry');
          break;
      default:
        setActiveForm(null);
        break;
    }
  };

  return (
    <>
    <div className="container">
      <h3>Welcome Admin: {admin} &emsp; <button className="btn btn-dark" onClick={() => handleButtonClick('Dashboard')}>Dashboard</button></h3>
      
    </div>
      <div className="container crud-btn">
        <button className="btn btn-primary" onClick={() => handleButtonClick('Insert')}>
          Insert
        </button>
        <button className="btn btn-warning" onClick={() => handleButtonClick('Update')}>
          Update
        </button>
        <button className="btn btn-success" onClick={() => handleButtonClick('Display')}>
          Display
        </button>
        <button className="btn btn-danger" onClick={() => handleButtonClick('Delete')}>
          Delete
        </button>
        <button className="btn btn-info" onClick={() => handleButtonClick('Enquiry')}>
         Enquiry
        </button>
      </div>
      {activeForm}
      <div className="container">
        <Routes>
          <Route path="/dashboard/customer/insert" element={<div />} />
          <Route path="/dashboard/customer/update" element={<div />} />
          <Route path="/dashboard/customer/display" element={<div />} />
          <Route path="/dashboard/customer/delete" element={<div />} />
          <Route path="/dashboard/customer/enquiry" element={<div />} />
        </Routes>
      </div>
    </>
  )
}

export default Dashboard;
